import type { RequestHandler as RH } from "../RequestHandler";

import Endpoints = require("../Endpoints");

import type {
	RESTGetAPISKUsResult,
	RESTGetAPISKUSubscriptionsQuery,
	RESTGetAPISKUSubscriptionsResult,
	RESTGetAPISKUSubscriptionResult,
} from "discord-api-types/v10";





class SkuMethods {








	public constructor(public requestHandler: RH) {}












	public async GetSkus(appId: string): Promise<RESTGetAPISKUsResult> {
		return this.requestHandler.request(Endpoints.APPLICATION_SKUS(appId), {}, "get", "json");
	}














	public async getSubscriptions(skuId: string, options: RESTGetAPISKUSubscriptionsQuery = {}): Promise<RESTGetAPISKUSubscriptionsResult> {
		return this.requestHandler.request(Endpoints.SKU_SUBSCRIPTIONS(skuId), options, "get", "json");
	}













	public async getSubscription(skuId: string, subscriptionId: string): Promise<RESTGetAPISKUSubscriptionResult> {
		return this.requestHandler.request(Endpoints.SKU_SUBSCRIPTION(skuId, subscriptionId), {}, "get", "json");
	}
}

export = SkuMethods;
